const setting = () =>
    import ('./index.vue');

export default [
      // 设置
      {
        path: "/historyTag",
        name: "historyTag",
        components: {
            default: setting,
        },
        meta: {
            nav: "historyTag",
            navName:"会话标签",
            keepAlive: true
        },
    },
]



// WEBPACK FOOTER //
// ./src/views/historyTag/index.js